export default "__VITE_ASSET__Cgg_QOAa__"